import { Captura, Section } from "./comunes";

// Sección de ayuda: Asesores comerciales
// Cubre: qué es, gestión en Configuración, asignación por empresa y desde el caso,
// bloque informativo en el detalle, CC sugerido en el correo al cliente, y filtro en Casos.

export default function AyudaAsesores() {
  return (
    <>
      <Section id="asesores" title="Asesores comerciales">
        <p>
          El <strong>asesor comercial</strong> es el contacto interno de Emprenet
          que atiende las cuentas de cada empresa cliente. Su dato vive en la{" "}
          <strong>empresa</strong>: cuando abres un caso, el sistema toma
          automáticamente el asesor de esa empresa y lo muestra en el caso.
          Si una empresa no tiene asesor asignado, el campo simplemente no aparece.
        </p>

        <h3 className="font-semibold mt-4 mb-1">Gestión del catálogo (Configuración → Asesores comerciales)</h3>
        <p>
          Solo los <strong>administradores</strong> pueden dar de alta, editar y
          desactivar asesores. Cada asesor tiene nombre, correo, teléfono y notas
          internas.
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>
            <strong>Activar / desactivar</strong>: el toggle guarda al instante.
            Un asesor inactivo no aparece en el selector al asignar empresas, pero
            los casos existentes siguen mostrando su nombre.
          </li>
          <li>
            <strong>Cartera de clientes</strong>: expande la fila del asesor para
            ver qué empresas tiene asignadas.
          </li>
          <li>
            <strong>Eliminar</strong>: no se puede borrar un asesor que tenga
            empresas en su cartera — primero reasigna o libera esas empresas.
            Desactívalo si ya no trabaja en el equipo.
          </li>
        </ul>
        <Captura
          src="/ayuda-img/asesores-panel.png"
          alt="Catálogo de asesores comerciales con cartera expandida"
          caption="Configuración → Asesores comerciales: catálogo con un asesor expandido mostrando su cartera de clientes."
        />

        <h3 className="font-semibold mt-4 mb-1">Asignar o cambiar el asesor de una empresa</h3>
        <p>
          Hay dos formas de asignar un asesor a una empresa (disponible para
          admin y soporte):
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>
            <strong>Configuración → Contactos</strong>: en la lista de empresas,
            cada fila tiene un selector de asesor. El cambio guarda al instante
            sin necesidad de un botón extra. Aquí la gerencia puede reasignar
            carteras completas de un asesor a otro.
          </li>
          <li>
            <strong>Desde el caso</strong>: en el detalle del caso, el bloque
            "Asesor comercial" trae un botón <strong>✎ Asignar</strong> (o{" "}
            <strong>✎ Cambiar</strong>) que abre una <strong>ventana ahí
            mismo</strong> — con buscador, la lista de asesores y la opción{" "}
            <strong>Quitar asesor</strong>. No te saca del caso: eliges, se
            guarda solo y el caso se actualiza al instante. Ojo: el asesor es{" "}
            <strong>de la empresa</strong>, así que el cambio aplica a{" "}
            <strong>todos sus casos</strong> — la ventana te lo recuerda.
          </li>
        </ul>
        <Captura
          src="/ayuda-img/asesor-modal-caso.png"
          alt="Ventana para cambiar el asesor comercial desde el caso"
          caption="El ✎ del caso abre esta ventana: buscador, lista de asesores y el aviso de que el cambio es de la empresa, no solo de ese caso."
        />
      </Section>

      <Section id="asesores-correo" title="Asesor en el caso y en correos al cliente">
        <h3 className="font-semibold mb-1">Detalle del caso</h3>
        <p>
          Cuando abres un caso, el bloque de información muestra el asesor de
          la empresa: nombre, correo y teléfono de un vistazo. Si la empresa
          todavía no tiene asesor, dice <em>"Sin asesor asignado"</em> y ahí
          mismo está el botón para asignarlo.
        </p>
        <Captura
          src="/ayuda-img/asesor-en-caso.png"
          alt="Bloque de asesor comercial en el detalle del caso"
          caption="El asesor aparece en el detalle del caso con nombre, correo y teléfono del contacto Emprenet."
        />

        <h3 className="font-semibold mt-4 mb-1">CC sugerido al escribir al cliente</h3>
        <p>
          Al abrir el modal de <strong>Enviar correo al cliente</strong>, si la
          empresa tiene asesor aparece un botón de un clic:{" "}
          <strong>"Copiar al asesor comercial (Nombre)"</strong>. Al hacer clic
          el asesor se agrega al campo CC del correo.
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>
            El asesor <strong>no se agrega solo</strong> — tú decides si incluirlo.
          </li>
          <li>
            <strong>Solo aparece en correos al cliente</strong>, nunca en correos
            al proveedor.
          </li>
          <li>
            Si ya está en el CC o es el destinatario, el chip no aparece.
          </li>
        </ul>
        <Captura
          src="/ayuda-img/correo-cc-asesor.png"
          alt="Chip para copiar al asesor en CC al escribir al cliente"
          caption="El chip aparece arriba del campo CC al enviar al cliente. Un clic y el asesor queda copiado."
        />

        <h3 className="font-semibold mt-4 mb-1">Filtro por asesor en la lista de casos</h3>
        <p>
          En <strong>Casos → Filtros</strong> hay un selector{" "}
          <strong>"Asesor comercial"</strong> para ver solo los casos de las
          empresas asignadas a un asesor específico. Útil para revisar la
          cartera de un asesor o reasignarla cuando hay un cambio en el equipo
          comercial.
        </p>
      </Section>
    </>
  );
}
